<template>
    <div>
        <monitoring-admin v-if="loggedUser && loggedUser.active && loggedUser.role === UserRoles.ADMIN"></monitoring-admin>
        <monitoring-regional-admin v-if="loggedUser && loggedUser.active && loggedUser.role === UserRoles.REGIONAL_ADMIN"></monitoring-regional-admin>
        <monitoring-applicant v-if="loggedUser && loggedUser.active && loggedUser.role === UserRoles.APPLICANT"></monitoring-applicant>
    </div>
</template>
<script>
    import {UserRoles} from '@/services';
    import MonitoringAdmin from './MonitoringAdmin';
    import MonitoringRegionalAdmin from './MonitoringRegionalAdmin';
    import MonitoringApplicant from './MonitoringApplicant';

    export default
    {
        components:
        {
            MonitoringAdmin,
            MonitoringRegionalAdmin,
            MonitoringApplicant
        },
        data()
        {
            return {
                loggedUser: {},
                UserRoles
            }
        },
        beforeMount()
        {
            this.loggedUser = this.$store.getters['Auth/loggedUser'];
        },
    };
</script>
